import { render, staticRenderFns } from "./safetyHat.vue?vue&type=template&id=230cb554&scoped=true&"
import script from "./safetyHat.vue?vue&type=script&lang=js&"
export * from "./safetyHat.vue?vue&type=script&lang=js&"
import style0 from "./safetyHat.vue?vue&type=style&index=0&id=230cb554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230cb554",
  null
  
)

export default component.exports